export const processAttendanceFile = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            const text = e.target.result;
            const lines = text.split('\n'); 
            const records = [];

            lines.forEach((line) => {
                const cleanLine = line.trim();
                if (!cleanLine || cleanLine.startsWith("No") || cleanLine.startsWith("[source")) return;

                const parts = cleanLine.split(/\s+/);

                if (parts.length >= 6) {
                    try {
                        const userIdRaw = parts[2]; 
                        const userId = parseInt(userIdRaw, 10).toString();
                        const timeStr = parts[parts.length - 1]; 
                        const dateStr = parts[parts.length - 2]; 
                        const isoDateStr = `${dateStr.replace(/\//g, '-')}T${timeStr}`;
                        const timestamp = new Date(isoDateStr);

                        if (!isNaN(timestamp.getTime())) {
                            records.push({
                                userId: userId,
                                timestamp: timestamp,
                                fecha: dateStr.replace(/\//g, '-'),
                                hora: timeStr,
                                raw: cleanLine
                            });
                        }
                    } catch (err) {
                        console.warn("Error parsing line:", cleanLine);
                    }
                }
            });
            resolve(records);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsText(file);
    });
};